// HW Only
export const API_URL_SET_BUSINESS_DETAILS = "/shop/api/b2b/checkout/setbusinessdetails";

// Manual order
export const API_URL_SUBMIT_MANUAL_ORDER = "/shop/api/b2b/checkout/submitmanualorder";

// export const API_URL_SET_PRODUCT_AND_PRODUCTUSER = "/shop/api/b2b/checkout/setproductandproductuser";
